import React from 'react'
import Navbar from '../../components/Navbar/Navbar'
import WorkInProgress from '../../components/WorkInProgress/WorkInProgress'

const MyCollectibles = () => {
  return (
    <main>
      <Navbar />
      <WorkInProgress />
    </main>
  )
}

export default MyCollectibles